import { render, staticRenderFns } from "./processKrasNonImprove.vue?vue&type=template&id=4ef0a4b2"
import script from "./processKrasNonImprove.vue?vue&type=script&lang=js"
export * from "./processKrasNonImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef0a4b2')) {
      api.createRecord('4ef0a4b2', component.options)
    } else {
      api.reload('4ef0a4b2', component.options)
    }
    module.hot.accept("./processKrasNonImprove.vue?vue&type=template&id=4ef0a4b2", function () {
      api.rerender('4ef0a4b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/processRam/processKrasNonImprove.vue"
export default component.exports